import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext, ThemeContext } from '../../../auth';
import { useMediaQuery } from 'react-responsive';
import { HeaderWeb, SidebarComponent } from '../../../components';
import { Button, Card, Col, Container, Form, InputGroup, Row, Spinner, Table } from 'react-bootstrap';
import { Formik } from 'formik';
import { BsFillPencilFill } from 'react-icons/bs';
import { FaWindowClose } from 'react-icons/fa';
import { ModalTambahPcpSewaDetailDatabase, ModalUbahPcpSewaDetail } from '../../../components/Modal';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../../api';


function PcpSewaEdit() {

    const { id } = useParams();
    const { theme } = useContext(ThemeContext);
    const { showSidebar, accessToken, userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pcpData, setPcpData] = useState({});
    const [pcpDetail, setPcpDetail] = useState([]);
    const [wapu, setWapu] = useState(pcpData?.isWapu || false);

    const retrievePCP = () => {

        axiosAuth.get(`/api/pcp/sewa?leadId=${id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setPcpData(res.data.data);


            }).catch(err => {
                console.error(err);

            })
    };

    const retrievePCPDetail = () => {

        axiosAuth.get(`/api/pcp/sewa/details?pcpId=${pcpData?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setPcpDetail(res.data.data);


            }).catch(err => {
                console.error(err);

            })
    };

    useEffect(() => {
        if (accessToken !== undefined && id !== undefined) retrievePCP();
    }, [accessToken, id]);

    useEffect(() => {
        if (accessToken !== undefined && pcpData?.id !== undefined) retrievePCPDetail();
    }, [accessToken, pcpData?.id]);

    const defaultValue = {
        projectName: pcpData?.projectName || "",
        description: pcpData?.description || "",
        status: pcpData?.status || "",
        franco: pcpData?.franco || "",
    };

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1)
    }

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);

    const handleDelete = async (itemId) => {
        const result = await Swal.fire({
            title: 'Apakah anda yakin ingin menghapus produk ini?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, hapus produk ini!',
            cancelButtonText: 'Batalkan',
        });

        if (result.isConfirmed) {

            try {
                const response = await axiosAuth.delete(`/api/pcp/sewa/details/${itemId}`,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            withCredentials: true,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                Swal.fire('Berhasil!', 'Produk berhasil dihapus', 'success');
                retrievePCPDetail();
            } catch (err) {
                console.error(err);
                Swal.fire('Error', 'Terjadi kesalahan saat menghapus produk!', 'error');
            }
        } else {
            <></>
        }
    };

    const [ppnPercentage, setPpnPercentage] = useState(11);

    const [totalHargaJual, setTotalHargaJual] = useState(0);

    useEffect(() => {

        setPpnPercentage(pcpData?.ppnPercentage || 11);

        if (pcpData && pcpData.isWapu !== undefined) {
            setWapu(pcpData.isWapu);
        }

    }, [pcpData]);

    useEffect(() => {

        const total = pcpDetail.reduce((acc, item) => {
            const subTotal =
                parseFloat(item.sellingPrice) *
                parseInt(item.quantity, 10) *
                parseInt((item.duration / 30), 10);
            return acc + subTotal;
        }, 0);

        setTotalHargaJual(total);
    }, [pcpDetail]);

    const ppnAmount = totalHargaJual * (ppnPercentage / 100);

    const grandTotalRaw = totalHargaJual + ppnAmount;

    // Pembulatan grandTotal
    const remainder = grandTotalRaw % 100;
    const grandTotal = remainder >= 50
        ? Math.round(grandTotalRaw + (100 - remainder))
        : Math.round(grandTotalRaw - remainder);

    const [showAddPcpSewaDetail, setShowAddPcpSewaDetail] = useState(false);

    const handleShowPcpSewaDetail = () => {
        setShowAddPcpSewaDetail(true)
    };

    const [rowSelected, setRowSelected] = useState({});
    const [showEditPcpSewaDetail, setShowEditPcpSewaDetail] = useState(false);

    const handleShowEditPcpSewaDetail = (item) => {
        setShowEditPcpSewaDetail(true);
        setRowSelected(item);
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputQty: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
    };

    const handleSubmitPCP = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        const dataPCP = {
            username: userInfo?.username,
            ppnPercentage: parseInt(ppnPercentage),
            ppn: ppnAmount,
            isWapu: wapu,
            grandTotal: grandTotal,
            salesTotal: totalHargaJual,
            ...values,
            status: 'pending'
        };

        try {

            const response = await axiosAuth.put(`/api/pcp/sewa/${pcpData?.id}`, dataPCP, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleBack();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengupdate Pcp',
                showConfirmButton: true,
            });

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {

            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengupdate Pcp',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }
    };

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }}>
            <SidebarComponent />
            <div
                id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'ms-2' : 'ms-3'}>
                    <Row >
                        <Col xs={6} lg={6} className='text-start'>
                            <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                Update PCP Sewa
                            </h3>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderWeb />
                        </Col>
                    </Row>
                </div>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmitPCP}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                    }) => {

                        return (
                            <Form onSubmit={handleSubmit}>
                                <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4'}>
                                    <Row>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='customer'>Customer</Form.Label>
                                            <Form.Control
                                                id='customer'
                                                type="text"
                                                value={
                                                    pcpData?.lead?.customer?.title?.titleName === "Others"
                                                        ? pcpData?.lead?.customer?.name
                                                        : `${pcpData?.lead?.customer?.title?.titleName}. ${pcpData?.lead?.customer?.name}`
                                                }
                                                readOnly
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='project'>Nama Projek*</Form.Label>
                                            <Form.Control
                                                id='project'
                                                type="text"
                                                value={values.projectName}
                                                onChange={handleChange("projectName")}
                                                required
                                                style={formStyles.input}
                                                disabled={disabled || pcpData?.lead?.status == 100}
                                            />
                                        </Col>
                                        <Col xs={12} lg={3} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='top'>Term of Payment*</Form.Label>
                                            <InputGroup >
                                                <Form.Control
                                                    id="top"
                                                    type="text"
                                                    value={pcpData?.lead?.customer?.top || ''}
                                                    readOnly
                                                    placeholder="Term of Payment"
                                                    style={formStyles.input}
                                                />
                                                <InputGroup.Text
                                                    style={formStyles.input}
                                                    id="basic-addon1"
                                                >
                                                    Hari
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </Col>
                                        <Col xs={12} lg={1} className="mb-3">
                                            <Form.Label style={formStyles.label}>Wapu</Form.Label>
                                            <Form.Check
                                                type='checkbox'
                                                id='default-checkbox'
                                                onChange={(e) => setWapu(e.target.checked)}
                                                checked={wapu}
                                                style={formStyles.label}
                                            // disabled={pcpDetail.length !== 0}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label}>Franco*</Form.Label>
                                            <Form.Control
                                                id='franco'
                                                type="text"
                                                value={values.franco}
                                                onChange={handleChange("franco")}
                                                required
                                                style={formStyles.input}
                                                disabled={disabled || pcpData?.lead?.status == 100}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='status'>Status Pcp</Form.Label>
                                            <Form.Control
                                                id='status'
                                                type="text"
                                                value={values.status}
                                                onChange={handleChange("status")}
                                                readOnly
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Group >
                                                <Form.Label style={formStyles.label} htmlFor='description'>Syarat dan ketentuan tambahan</Form.Label>
                                                <Form.Control
                                                    id="description"
                                                    as="textarea"
                                                    rows={3}
                                                    value={values.description}
                                                    onChange={handleChange("description")}
                                                    placeholder="Syarat dan ketentuan tambahan"
                                                    style={formStyles.input}
                                                    disabled={disabled || pcpData?.lead?.status == 100}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>

                                <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4 me-3'}>
                                    <h3 className='text-center' style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222', fontSize: isMobile ? '25px' : '38px' }}>
                                        PCP Detail
                                    </h3>
                                    <div>
                                        <Row>
                                            <Col xs={12} lg={6} className='text-start'>
                                                <Button
                                                    variant='btn'
                                                    id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                    onClick={handleShowPcpSewaDetail}
                                                    disabled={disabled || pcpData?.lead?.status == 100}
                                                >
                                                    Tambah
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>

                                    <Table className='mt-4' bordered responsive data-bs-theme={theme === "light" ? "dark" : "light"}>
                                        <thead>
                                            <tr style={{ fontFamily: 'Poppins-Regular', textAlign: 'center' }}>
                                                <th
                                                    style={{
                                                        textAlign: 'left'
                                                    }}
                                                >
                                                    Nama Produk
                                                </th>
                                                <th>Jenis Produk</th>
                                                <th>Durasi (Bulan)</th>
                                                <th
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Harga Beli
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Harga Sewa Perbulan
                                                </th>
                                                <th>Qty</th>
                                                <th
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Sub Total
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    %
                                                </th>
                                                <th>Ubah</th>
                                                <th>Hapus</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pcpDetail.map((item, index) => {

                                                const calculatedSubTotal = parseFloat(item.sellingPrice) * parseInt(item.quantity, 10) * parseInt((item.duration / 30), 10);

                                                const marginTotal = ((parseFloat(item.nett) / parseFloat(calculatedSubTotal))) * 100;

                                                const validateMargin = wapu ? (marginTotal.toFixed(2) <= 26 ? false : true) : (marginTotal.toFixed(2) <= 15 ? false : true)

                                                const subTotalSewa = parseFloat(item.sellingPrice) * parseInt(item.quantity, 10) * parseInt((item.duration / 30), 10);

                                                return (
                                                    <tr key={index} style={{ fontFamily: 'Poppins-Light', textAlign: 'center' }}>
                                                        <td style={{
                                                            textAlign: 'left',
                                                            width: '350px'
                                                        }}>
                                                            {item?.productName}
                                                        </td>
                                                        <td>
                                                            {item?.category?.categoryName}
                                                        </td>
                                                        <td>
                                                            {item?.duration ? (item.duration / 30) : 0}
                                                        </td>
                                                        <td style={{
                                                            textAlign: 'right'
                                                        }}>
                                                            {numberFormat(item.buyingPrice)}
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'right'
                                                            }}
                                                        >
                                                            {numberFormat(item.sellingPrice)}
                                                        </td>
                                                        <td>
                                                            {item.quantity || 0}
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'right'
                                                            }}
                                                        >
                                                            {numberFormat(subTotalSewa || 0)}
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            <span style={{
                                                                color: validateMargin == true ? '#16C47F' : '#FF0060'
                                                            }}>
                                                                {marginTotal.toFixed(2) ? `${marginTotal.toFixed(2)}%` : '0%'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <Button
                                                                    variant='btn'
                                                                    onClick={() => handleShowEditPcpSewaDetail(item)}
                                                                    style={{
                                                                        border: 'none',
                                                                        backgroundColor: 'transparent',
                                                                    }}
                                                                    disabled={disabled || pcpData?.lead?.status == 100}
                                                                >
                                                                    &nbsp;<BsFillPencilFill size={20} color={theme === 'light' ? '#12B3ED' : '#006CB8'} />&nbsp;
                                                                </Button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <Button
                                                                    variant='btn'
                                                                    onClick={() => handleDelete(item?.id)}
                                                                    style={{
                                                                        border: 'none',
                                                                        backgroundColor: 'transparent',
                                                                    }}
                                                                    disabled={disabled || pcpData?.lead?.status == 100}
                                                                >
                                                                    &nbsp;<FaWindowClose size={20} color='#FF0060' />&nbsp;
                                                                </Button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>

                                    <div className='mt-5'>
                                        <Row>
                                            <Col xs={12} lg={6} ></Col>
                                            <Col xs={12} lg={2} ></Col>
                                            <Col xs={12} lg={4} >
                                                <Card
                                                    data-bs-theme={theme === 'light' ? 'dark' : ''}>
                                                    <Card.Body>
                                                        <div>
                                                            <Form.Label style={formStyles.label} htmlFor='totalSelling'>Total Harga Jual</Form.Label>
                                                            <Form.Control
                                                                id='totalSelling'
                                                                type='text'
                                                                className='mb-3'
                                                                value={numberFormat(totalHargaJual) || ""}
                                                                readOnly
                                                                style={formStyles.input}
                                                            />
                                                            <Form.Label style={formStyles.label} htmlFor='ppn'>PPN%</Form.Label>
                                                            <Form.Control
                                                                id='ppn'
                                                                type='text'
                                                                className='mb-3'
                                                                value={ppnPercentage}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (/^\d*$/.test(value)) {
                                                                        setPpnPercentage(value);
                                                                    }
                                                                }}
                                                                required
                                                                style={formStyles.input}
                                                            />
                                                            <Form.Label style={formStyles.label} htmlFor='ppnValue'>PPN Amount</Form.Label>
                                                            <Form.Control
                                                                id='ppnValue'
                                                                type='text'
                                                                className='mb-3'
                                                                value={numberFormat(ppnAmount) || ''}
                                                                readOnly
                                                                style={formStyles.input}
                                                            />
                                                            <Form.Label style={formStyles.label} htmlFor='grandTotal'>Grand Total</Form.Label>
                                                            <Form.Control
                                                                id='grandTotal'
                                                                type='text'
                                                                className='mb-3'
                                                                value={numberFormat(grandTotal) || ''}
                                                                readOnly
                                                                style={formStyles.input}
                                                            />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                                <div className='text-end mt-4 mb-3'>
                                                    {pcpData?.lead?.status == 100 ?
                                                        (
                                                            <>
                                                            </>
                                                        )
                                                        :
                                                        (
                                                            <>
                                                                {isSubmitting ? (
                                                                    <Button
                                                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                                        variant='btn'
                                                                        disabled
                                                                        style={{ minWidth: '90px' }}
                                                                    >
                                                                        <Spinner
                                                                            animation="border"
                                                                            size='sm'
                                                                        />
                                                                    </Button>
                                                                ) : (
                                                                    <Button
                                                                        variant='btn'
                                                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                                        type='submit'
                                                                        disabled={disabled ||
                                                                            pcpDetail == 0
                                                                        }
                                                                    >
                                                                        Simpan
                                                                    </Button>
                                                                )}
                                                            </>
                                                        )
                                                    }

                                                    <Button
                                                        variant='secondary'
                                                        className='ms-3'
                                                        onClick={handleBack}
                                                        style={{ fontFamily: 'Poppins-Regular', minHeight: '45px' }}
                                                        disabled={pcpData?.grandTotal != grandTotal}
                                                    >
                                                        Kembali
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
            <ModalTambahPcpSewaDetailDatabase
                showAddPcpSewaDetail={showAddPcpSewaDetail}
                setShowAddPcpSewaDetail={setShowAddPcpSewaDetail}
                formStyles={formStyles}
                pcpData={pcpData}
                accessToken={accessToken}
                retrievePCPDetail={retrievePCPDetail}
            />

            <ModalUbahPcpSewaDetail
                rowSelected={rowSelected}
                showEditPcpSewaDetail={showEditPcpSewaDetail}
                setShowEditPcpSewaDetail={setShowEditPcpSewaDetail}
                formStyles={formStyles}
                pcpData={pcpData}
                retrievePCPDetail={retrievePCPDetail}
            />

        </div>
    )
}

export default PcpSewaEdit
